export default "__VITE_ASSET__$fu5q6zM__"